"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  .resizeable-modal {\n    .ant-modal-content {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: stretch;\n      .ant-modal-body {\n        flex: 1;\n        overflow: auto;\n        img {\n          max-width: 100%;\n        }\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  cursor: nwse-resize;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: move;\n  min-height: 50px;\n  width: 100%;\n  margin-top: -18px;\n  margin-left: -22px;\n  margin-right: -22px;\n  padding: 18px 22px 0 22px;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResizeableModal = void 0;

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var Modal_1 = require("./Modal");

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

var MIN_SIZE = 200;

function ResizeableModal(_a) {
  var title = _a.title,
      children = _a.children,
      modalProps = __rest(_a, ["title", "children"]);

  var theme = react_1["default"].useContext(styledTypes_1.ThemeContext);
  var size = react_1["default"].useRef({
    x: 500,
    y: 300
  }).current;
  var transform = react_1["default"].useRef({
    x: (window.innerWidth - size.x) / 2,
    y: 0
  }).current;
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(ResizeableGlobalStyle, null), react_1["default"].createElement(Modal_1.Modal, Object.assign({}, modalProps, {
    transitionName: '',
    className: 'resizeable-modal',
    style: {
      transform: "translateX(".concat(transform.x, "px) translateY(").concat(transform.y, "px)"),
      maxWidth: '90vw',
      maxHeight: '90vw',
      minWidth: 100,
      minHeight: 100,
      width: size.x,
      height: size.y,
      margin: 0
    },
    customTitle: react_1["default"].createElement(DraggableTitle, {
      onMouseDown: function onMouseDown(event) {
        var targetElement = event.target;
        var modal = targetElement.closest('.feature-modal');
        var startTransform = Object.assign({}, transform);
        var startClient = {
          x: event.clientX,
          y: event.clientY
        };

        var move = function move(event) {
          if (modal) {
            var deltaX = event.clientX - startClient.x;
            var deltaY = event.clientY - startClient.y;
            transform.x = startTransform.x + deltaX;
            transform.y = startTransform.y + deltaY;
            modal.style.transform = "translateX(".concat(transform.x, "px) translateY(").concat(transform.y, "px)");
          }
        };

        var up = function up() {
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', up);
        };

        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', up);
      }
    }, title ? react_1["default"].createElement(Typography_1.H2, {
      isBlock: false,
      style: {
        lineHeight: 1,
        paddingTop: theme['@size-xs']
      }
    }, title) : null)
  }), children, react_1["default"].createElement(Resizer, {
    onMouseDown: function onMouseDown(event) {
      var targetElement = event.target;
      var modal = targetElement.closest('.feature-modal');
      var startSize = Object.assign({}, size);
      var startClient = {
        x: event.clientX,
        y: event.clientY
      };

      var move = function move(event) {
        if (modal) {
          var deltaX = event.clientX - startClient.x;
          var deltaY = event.clientY - startClient.y;
          size.x = Math.max(MIN_SIZE, Math.min(startSize.x + deltaX, window.innerWidth * 0.9));
          size.y = Math.max(MIN_SIZE, Math.min(startSize.y + deltaY, window.innerHeight * 0.9));
          modal.style.width = "".concat(size.x, "px");
          modal.style.height = "".concat(size.y, "px");
        }
      };

      var up = function up() {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };

      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    }
  })));
}

exports.ResizeableModal = ResizeableModal;
var DraggableTitle = styledTypes_1.styled.div(_templateObject());
var Resizer = styledTypes_1.styled.div(_templateObject2());
var ResizeableGlobalStyle = (0, styled_components_1.createGlobalStyle)(_templateObject3());